/**
 * THE DATE FORMAT RULE (Rob, 17 Jul): every date shown to a user is
 * DD/MM/YYYY (or a friendly en-GB long form) — NEVER ISO/US order.
 * ISO (yyyy-mm-dd) is for wire formats and API payloads only.
 *
 * String-sliced rather than new Date(): parsing 'yyyy-mm-dd' with Date()
 * lands on UTC midnight and can shift a day in some timezones. Splitting the
 * string is deterministic everywhere.
 */
export function formatDateGB(iso) {
  if (!iso) return '';
  const s = String(iso).slice(0, 10);
  const [y, m, d] = s.split('-');
  if (y && m && d) return `${d}/${m}/${y}`;
  return s;
}
